import { HttpErrorResponse } from '@angular/common/http';

/**
 * True when the request never reached the server (offline, DNS failure, blocked by a service worker).
 * Such a failure says nothing about the member's session and must not be read as "signed out".
 */
export const isNetworkFailure = (error: unknown): boolean =>
  error instanceof HttpErrorResponse && error.status === 0;
